import React from 'react';

import ContactManagementView from '@sophocles/components/contacts/ContactManagementView';

/**
 * CustomerContactsTab - Display and manage customer-level contacts
 */
function CustomerContactsTab({ customerId }) {
  return <ContactManagementView customerId={customerId} initialScopeFilter="customer" lockScopeFilter={true} />;
}

export default CustomerContactsTab;
